// extracted by mini-css-extract-plugin
export default {"page":"UserSettingsPage_page__j+71a","userInfo":"UserSettingsPage_userInfo__UmAGO"};